'use strict';

module.exports = {
  GRID: 'grid',
  LIST: 'list'
};


/** WEBPACK FOOTER **
 ** ./constants/GalleryLayouts.js
 **/